<template>
  <sidebar-menu style="max-width: 700px" id="sidebarViewer" :menu="menu" :theme="theme">
      <inventry-generator></inventry-generator>
  </sidebar-menu>
</template>

<script>
import InventryGenerator from './InventryGenerator'

export default {
  name: 'SideBarInventryGenerator',
  data() {
    return {
      menu: [{ component: InventryGenerator }],
      theme: 'white-theme'
    }
  }
}
</script>
<style>
#sidebarViewer {
  position: relative;
  float: right;
  height: 87%;
}

.formGroupTitle {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/sideBarInventryGenerator/SideBarInventryGenerator.vue